import React, { FC } from 'react';
import { helpers } from '@minecraft.utils';
import { CLAIM_ACCOUNT_STEP, Instance, ModalStepProps } from '../types';
import { StyledLinkButton } from './ModalBodyStyles';

type Props = Pick<ModalStepProps, 'setStep'> & Pick<Instance, 'setInstance'>;

const SelectCountry: FC<Props> = ({ setStep, setInstance }) => {
  const instances = helpers.getAllowedInstances();

  const onSetInstance = (i) => {
    setInstance(i);
    setStep(CLAIM_ACCOUNT_STEP.LOGIN);
  };

  return (
    <>
      {instances.map((i) => (
        <StyledLinkButton color="link" key={i.value} onClick={() => onSetInstance(i)}>
          {i.item}
        </StyledLinkButton>
      ))}
    </>
  );
};

export default SelectCountry;
